import { gql } from "@apollo/client";

export const LIVE_STREAMS_SUBSCRIPTION = gql`
    subscription LiveStreamsSubscription {
        liveStreams {
            id
            streamTeamMember {
                id
                player {
                    id
                    name
                    avatarUrl
                }
                twitchUsername
                twitchAuth {
                    profileImageUrl
                }
            }
            isLive
            streamTitle
            gameName
            viewerCount
        }
    }
`;
